import { AccountProfile } from "../pages/AccountProfile";
import { Employees } from "../pages/Employees";
import EmployeeEdit from "../pages/Employees/EmployeeEdit";
import ProfileManagement from "../pages/ProfileManagement";
import { Export } from "../pages/Export";
import { Reports } from "../pages/Reports";
import { Settings } from "../pages/Settings";
import { Sites } from "../pages/Sites";
import { TimeCard } from "../pages/TimeCard";
import AttendanceTagsView from "../components/timecard/AttendanceTagsView";
import ManagerTimesheetRoutes from "../pages/mobile/ManagerTimesheet";
import {
  ManagerEmployeeTimesheetDetail,
  ManagerTimesheetFilters
} from "../components/mobile/m-timesheet";
import {
  Route,
  createBrowserRouter,
  createRoutesFromElements,
} from "react-router-dom";
import { Main } from "../pages/main";
import { MainContainer } from "../pages/mainContainer";
import { ScheduleV2 } from "../pages/scheduleV2";
import { WelcomePage } from "../pages/WelcomePage";
import ProfilePage from "../pages/ProfilePage";
import TimesheetPage from "../pages/Timesheet";
import TimecardV2 from "../pages/TimeCardv2";
import RecordDetailsComponent from "../components/timecard/recordDetails";
import { WhoIsWorking } from "../pages/WhoIsWorking";
import {
  MobileDashboard,
  MobileScheduleDetails,
  DynamicNotificationMobile,
  WhoIsInEmployeesView,
  WhoIsInDetails,
  UnavailabilityForm,
} from "../pages/mobile";
// import { MobileFilter } from "../components/mobile/mobileDashboard";
import {
  AppleCalendar,
  RequestTimeOffStepper,
  ManagerTimeoffList,
  MobileTimeoffDetails,
  MobileTimeoffCategoryDetail,
  TimeOffScreen,
  MobileViewAllUpcomingTimeoff,
  MobileViewAllPastTimeoff,
} from "../components";
import VacationDetailsScreen from "../components/mobile/timeoff/vacationDetails";
import RequestTimeOffV2 from "../pages/TimeOffV2";
import { MobileNotifications } from "../pages/mobile";
import { TimeOffDetailsView, ViewAllTimeoff } from "../components/timeOff";
import Emp_Timecard from "../pages/Emp_Timecard/Emp_Timecard";
import Emp_TimecardDetail from "../pages/Emp_Timecard/Emp_TimecardDetail";
import TimecardFilter from "../pages/Emp_Timecard/Emp_TimecardFilter";
import FilterSelectSite from "../pages/Emp_Timecard/FilterSelectSite";
import { traditionalPolicy } from "../pages/Traditional";
import CreateTimeoffRule from "../pages/TimeoffRules";
import TimeoffCategories from "../pages/TimeoffCategories";
import { AddTimeOffCategory } from "../pages/TimeoffCategory";
import { NotificationsWeb } from "../pages/notificationsV2";
import DynamicNotificationDetail from "../pages/notificationDetailsV2";
import { CannotWorkActionables } from "../components/mobile/scheduleDetails";
import { MobileTradeForm } from "../components/mobile/shiftSwap/trade";
import TimesheetMobileView from "../components/mobile/m-timesheet/TimesheetMobileView";
import ChangeHistoryPage from "../components/mobile/m-timesheet/ChangeHistoryMobile";
import TimeCardDayDetailPage from "../components/mobile/m-timesheet/TimeCardDayDetail";
import TimecardRecordDetail from "../components/mobile/m-timesheet/TimecardRecordDetail";
import BreakDetailsPage from "../components/mobile/m-timesheet/BreakDetailsPage";
import TimecardRecordNotesListData from "../components/mobile/m-timesheet/TimecardNotesRecord";
import ViewTrackingMapPage from "../components/mobile/geoTracking/ViewTrackingMap";
import GeoAttendanceTrackingPage from "../pages/mobile/geoTracking/AttendenceTrackingPage";
import AddTimeSheetEntryComponent from "../components/mobile/m-timesheet/AddTimesheetEntry";
import BreakManagerPage from "../components/mobile/m-timesheet/BreakManagerPage";
import TimecardRequest from "../pages/mobile/TimecardRequest";
import TimesheetWithSidebarPage from "../pages/TimesheetWithSidebarPage";
import TestNavigation from "../pages/TestNavigation";
import { PWAInstallPage } from "../pages/PWAInstallPage";
import { PunchPage } from "../pages/PunchPage";
import WebDashboard from "../pages/WebDashboard";
import SchedulingToolPage from "../pages/SchedulingToolPage";
import ManagerEmpTimecardRecordDetail from "../components/mobile/m-timesheet/ManagerEmpTimecardRecordDetail";
import BreakDetailsPageMgrView from "../components/mobile/m-timesheet/BreakDetailsPageMgrView";
import { OpenShiftsSelection, OpenShiftsMaster, OpenShiftsHistory, OpenShiftDetails } from "../pages/OpenShifts";
import OpenShiftNotificationDetail from "../pages/notificationDetailsV2/OpenShiftNotificationDetail";
import TimesheetApprovalPage from "../pages/mobile/TimesheetApprovalPage";
import ScheduleUploadPage from "../pages/ScheduleUpload";
import ScheduleReviewPage from "../pages/ScheduleReview";
import ManagerApprovalPage from "../pages/ManagerApproval";
import TrackingSessionsPage from "../pages/TrackingSessions";
import SessionDetailsPage from "../pages/TrackingSessions/SessionDetails";

export const DrawerRoutes = [
  {
    path: "/Dashboard",
    component: WelcomePage,
  },
  {
    path: "/m-timesheet-approval/:start_date/:end_date/:employee_id",
    component: TimesheetApprovalPage,
  },
  {
    path: "/AccountProfile",
    component: AccountProfile,
  },
  {
    path: "/profile-management",
    component: ProfileManagement,
  },
  {
    path: "/TimeCard",
    component: TimeCard,
  },
  {
    path: "/report/timecard-activity-report",
    component: Reports,
  },
  {
    path: "/Employees",
    component: Employees,
  },
  {
    path: "/emp/edit/:id",
    component: EmployeeEdit,
  },
  {
    path: "/Export",
    component: Export,
  },
  {
    path: "/TimeClock",
    component: TimeCard,
  },
  {
    path: "/Sites",
    component: Sites,
  },
  {
    path: "/Schedule",
    // component: Schedule,
    // component: MySchedule,
    component: ScheduleV2,
  },
  {
    path: "/scheduling-tool",
    component: SchedulingToolPage,
  },
  {
    path: "/Settings",
    component: Settings,
  },
  {
    path: "/Timesheet",
    component: TimesheetPage,
  },
  {
    path: "/profilePage",
    component: ProfilePage,
  },
  {
    path: "/notifications",
    // component: NotificationScreen,
    component: NotificationsWeb,
  },
  {
    path: "/notificationDetail",
    component: DynamicNotificationDetail,
  },
  {
    path: "/timecardv2",
    component: TimecardV2,
  },
  {
    path: "/timecardv2/details",
    component: RecordDetailsComponent,
  },
  // {
  //     path: "/time-off-request",
  //     component: TimeOffRequest,
  // },
  {
    path: "/who-is-working",
    component: WhoIsWorking,
  },
  {
    path: "/time-off-request",
    component: RequestTimeOffV2,
  },
  {
    path: "/time-off-request-v2",
    component: RequestTimeOffV2,
  },
  {
    path: "/time-off-request-v2/details",
    component: TimeOffDetailsView,
  },
  {
    path: "/view-all-timeoff-requests",
    component: ViewAllTimeoff,
  },
  {
    path: "/create-time-off-rule",
    component: CreateTimeoffRule,
  },
  {
    path: "/time-off-policies",
    component: TimeoffCategories,
  },
  {
    path: "/create-timeoff-category",
    component: AddTimeOffCategory,
  },

  // PWA Install Page
  {
    path: "/install-app",
    component: PWAInstallPage,
  },

  // Punch Page
  {
    path: "/punch",
    component: PunchPage,
  },

  // webview/mobile routes
  {
    path: "/mobile-dashboard",
    component: MobileDashboard,
  },
  {
    path: "/web-dashboard",
    component: WebDashboard,
  },
  {
    path: "/m-view-employees",
    component: WhoIsInEmployeesView,
  },
  // {
  //   path: "/m-filter",
  //   component: MobileFilter,
  // },
  {
    path: "/m-calendar",
    component: AppleCalendar,
  },
  {
    path: "/m-scheduling-tool",
    component: SchedulingToolPage,
  },
  {
    path: "/m-schedule-details",
    component: MobileScheduleDetails,
  },
  {
    path: "/m-cannotwork-actionables",
    component: CannotWorkActionables,
  },
  {
    path: "/m-timeoff",
    component: TimeOffScreen,
  },
  {
    path: "/m-timeoff-category/:categoryCode",
    component: MobileTimeoffCategoryDetail,
  },
  {
    path: "/m-manager-timeoff",
    component: ManagerTimeoffList,
  },
  {
    path: "/m-vacation-details",
    component: VacationDetailsScreen,
  },
  {
    path: "/m-request-timeoff",
    component: RequestTimeOffStepper,
  },
  {
    path: "/m-timeoff-details",
    component: MobileTimeoffDetails,
  },
  {
    path: "/m-notifications",
    component: MobileNotifications,
  },
  {
    path: "/m-notification-detail",
    component: DynamicNotificationMobile,
  },
  {
    path: "/m-view-all-upcoming-timeoff",
    component: MobileViewAllUpcomingTimeoff,
  },
  {
    path: "/m-view-all-past-timeoff",
    component: MobileViewAllPastTimeoff,
  },
  {
    path: "/m-swap-trade",
    component: MobileTradeForm,
  },
  {
    path: "/m-unavailability-form",
    component: UnavailabilityForm,
  },
  {
    path: "/m-who-is-in-details",
    component: WhoIsInDetails,
  },
  {
    path: "/open-shifts",
    component: OpenShiftsSelection,
  },
  {
    path: "/open-shifts-master",
    component: OpenShiftsMaster,
  },
  {
    path: "/open-shifts-history",
    component: OpenShiftsHistory,
  },
  {
    path: "/open-shift-details/:id",
    component: OpenShiftDetails,
  },
  {
    path: "/test-openshift-notif-detail",
    component: OpenShiftNotificationDetail,
  },

  //Employee_Timecard
  {
    path: "/test-Emp_Timecard",
    component: Emp_Timecard,
  },
  {
    path: "/test-Emp_TimecardDetails/:date/:time",
    component: Emp_TimecardDetail,
  },
  {
    path: "/test-Emp_TimecardFilter",
    component: TimecardFilter,
  },
  {
    path: "/test-FilterSelectSite",
    component: FilterSelectSite,
  },

  //Employee Timesheet
  {
    path: "/m-timesheet",
    component: TimesheetMobileView,
  },
  {
    path: "/timesheet-with-sidebar",
    component: TimesheetWithSidebarPage,
  },
  {
    path: "/test-daydetail/:date",
    component: TimeCardDayDetailPage,
  },
  {
    path: "/m-timecard-record-detail/:id",
    component: TimecardRecordDetail,
  },
  {
    path: "/m-timesheet-approval/:start_date/:end_date/:employee_id",
    component: TimesheetApprovalPage,
  },
  {
    path: "/break-details",
    component: BreakDetailsPage,
  },
  {
    path: "/m-changeHistory/:id",
    component: ChangeHistoryPage,
  },
  {
    path: "/m-notesList/:id",
    component: TimecardRecordNotesListData,
  },
  {
    path: "/m-add-timesheet-entry",
    component: AddTimeSheetEntryComponent,
  },
  {
    path: "/m-timecard-request",
    component: TimecardRequest,
  },
  {
    path: "/m-manage-breaks",
    component: BreakManagerPage,
  },


  // Manager Timesheet
  {
    path: "/m-manager-timesheet",
    component: ManagerTimesheetRoutes,
  },
  {
    path: "/m-manager-timesheet/:employeeId",
    component: ManagerEmployeeTimesheetDetail,
  },
  {
    path: "/m-manager-timesheet-filters",
    component: ManagerTimesheetFilters,
  },
  {
    path: "/m-manager-timeoff-filters",
    component: ManagerTimesheetFilters,
  },
  {
    path: '/m-manager-timecard-record-detail/:id',
    component: ManagerEmpTimecardRecordDetail,
  },
    {
    path: "/break-details-mgr-view",
    component: BreakDetailsPageMgrView,
  },


  //Time off
  {
    path: "/test-traditional-policy",
    component: traditionalPolicy,
  },
  //Attendance Tracking
  {
    path: "/m-attendance-tracking",
    component: GeoAttendanceTrackingPage,
  },
  {
    path: "/m-view-on-map/:tracking_uuid?/:emp_account_id?",
    component: ViewTrackingMapPage,
  },
  {
    path: "/m-attendance-tags/:id",
    component: AttendanceTagsView
  },
  {
    path: "/test-navigation",
    component: TestNavigation
  },
  {
    path: "/test-geotracking",
    component: GeoAttendanceTrackingPage
  },

  // Tracking Sessions (Firestore)
  {
    path: "/tracking-sessions",
    component: TrackingSessionsPage,
  },
  {
    path: "/tracking-sessions/:sessionId",
    component: SessionDetailsPage,
  },

  // Schedule Upload (Manager Portal)
  {
    path: "/schedule-upload",
    component: ScheduleUploadPage,
  },
  {
    path: "/schedule-upload/review",
    component: ScheduleReviewPage,
  },
  {
    path: "/schedule-upload/approval",
    component: ManagerApprovalPage,
  },
] as Array<{ path: string; component: React.ElementType }>;

export const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="" element={<MainContainer />}>
      <Route index element={<Main />} />
      <Route path="/*" element={<Main />} />
    </Route>
  )
);
